// tab仓库
const tabs = {
  state: {
    options: [],
    activeIndex: '',
    userInfo: {}
  },
  mutations: {
    // 添加tabs
    ADD_TABS (state, data) {
     state.options.push(data);
    },
    // 删除tabs
    DELETE_TABS (state, route) {
      let index = 0;
      for (let option of state.options) {
        if (option.route === route) {
          break;
        }
        index++;
      }
      state.options.splice(index, 1);
    },
    // 设置当前激活的tab
    SET_ACTIVE_INDEX (state, index) {
      state.activeIndex = index;
    },
    // 设置详情信息
    save_detail_info (state, info) {
      state.userInfo = info;
    },
    // 清空数据
    SET_CLEAR_TABS(state){
      state.options = [];
      state.activeIndex = '';
      state.userInfo = {};
    }
  },
  actions: {
    TabsAddTabs({commit},data){
      commit('ADD_TABS',data);
    },
    TabsDeleteTabs({commit},data){
      commit('DELETE_TABS',data);
    },
    TabsSetActiveIndex({commit},data){
      commit('SET_ACTIVE_INDEX',data);
    },
    ClearTabs({commit}){
      commit("SET_CLEAR_TABS");
    }
  }
};

export default tabs;



// WEBPACK FOOTER //
// ./src/store/modules/tabs.js